import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 24 24"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M10.01 7.517a2.435 2.435 0 0 0-3.416 0 2.36 2.36 0 0 0 0 3.363 2.435 2.435 0 0 0 3.417 0 2.36 2.36 0 0 0 0-3.363Zm-4.4-.994a3.835 3.835 0 0 1 5.386 0 3.76 3.76 0 0 1 0 5.352 3.835 3.835 0 0 1-5.387 0 3.76 3.76 0 0 1 0-5.352ZM14.1 9.479a.7.7 0 0 1 .7-.7H21.3a.7.7 0 0 1 .7.7v2.801a.7.7 0 0 1-.7.7h-6.499a.7.7 0 0 1-.7-.7V9.48Zm1.4.7v1.401H20.6V10.18h-5.099Zm-1.4 4.79a.7.7 0 0 1 .7-.7h4.482a.7.7 0 0 1 .7.7v2.801a.7.7 0 0 1-.7.7h-4.482a.7.7 0 0 1-.7-.7v-2.8Zm1.4.7v1.401h3.082v-1.4h-3.082Zm-10.311 0c-.995 0-1.79.797-1.79 1.765v.448a.7.7 0 1 1-1.4 0v-.448c0-1.754 1.435-3.165 3.19-3.165h6.225a.7.7 0 1 1 0 1.4H5.19Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
